module.exports = __webpack_public_path__ + "img/cross.3040d695.svg";